export default {
  contents(state) {
    return state.topic?.contents
  },
}
